// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Skills_skillsSection__mbSY2 {
    position: relative;
    width: 100%;
    margin-bottom: 1vh;
}

.Skills_bgText__zUqP9 {
    display: none;
}

.Skills_skillsFrame__4E5U- {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1vw;
    padding: 1vw;
}

.Skills_skillIcon__yMrsd {
    width: 3vw;
    height: 3vw;
    object-fit: contain;
    transition: transform 0.3s ease;
    cursor: pointer;
}

.Skills_skillIcon__yMrsd:hover {
    transform: translateY(-5px) scale(1.1) rotate(5deg);
}

/*-----------------------------PORTRAIT MODE---------------------------------*/
@media (max-aspect-ratio: 1/1) {
    .Skills_skillsSection__mbSY2 {
        width: 80vw;
        margin: 2vh auto;
    }

    .Skills_skillsFrame__4E5U- {
        gap: 4vw;
        padding: 2vw;
    }

    .Skills_skillIcon__yMrsd {
        width: 10vw;
        height: 10vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skills.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,mDAAmD;AACvD;;AAEA,8EAA8E;AAC9E;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".skillsSection {\n    position: relative;\n    width: 100%;\n    margin-bottom: 1vh;\n}\n\n.bgText {\n    display: none;\n}\n\n.skillsFrame {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 1vw;\n    padding: 1vw;\n}\n\n.skillIcon {\n    width: 3vw;\n    height: 3vw;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n    cursor: pointer;\n}\n\n.skillIcon:hover {\n    transform: translateY(-5px) scale(1.1) rotate(5deg);\n}\n\n/*-----------------------------PORTRAIT MODE---------------------------------*/\n@media (max-aspect-ratio: 1/1) {\n    .skillsSection {\n        width: 80vw;\n        margin: 2vh auto;\n    }\n\n    .skillsFrame {\n        gap: 4vw;\n        padding: 2vw;\n    }\n\n    .skillIcon {\n        width: 10vw;\n        height: 10vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skillsSection": `Skills_skillsSection__mbSY2`,
	"bgText": `Skills_bgText__zUqP9`,
	"skillsFrame": `Skills_skillsFrame__4E5U-`,
	"skillIcon": `Skills_skillIcon__yMrsd`
};
export default ___CSS_LOADER_EXPORT___;
